/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of an Image
 * @export
 * @interface Image
 */
export interface Image {
    /**
     * Type of the image, can be PRIMARY or GALLERY
     * @type {string}
     * @memberof Image
     */
    imageType?: ImageImageTypeEnum;
    /**
     * Format of the image, can be zoom, product, thumbnail, store, cartIcon, etc.
     * @type {string}
     * @memberof Image
     */
    format?: string;
    /**
     * URL address of the image
     * @type {string}
     * @memberof Image
     */
    url?: string;
    /**
     * Tooltip content which is visible while image mouse hovering
     * @type {string}
     * @memberof Image
     */
    altText?: string;
    /**
     * Index of the image while displayed in gallery
     * @type {number}
     * @memberof Image
     */
    galleryIndex?: number;
}


/**
 * @export
 */
export const ImageImageTypeEnum = {
    Primary: 'PRIMARY',
    Gallery: 'GALLERY'
} as const;
export type ImageImageTypeEnum = typeof ImageImageTypeEnum[keyof typeof ImageImageTypeEnum];


/**
 * Check if a given object implements the Image interface.
 */
export function instanceOfImage(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ImageFromJSON(json: any): Image {
    return ImageFromJSONTyped(json, false);
}

export function ImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Image {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'imageType': !exists(json, 'imageType') ? undefined : json['imageType'],
        'format': !exists(json, 'format') ? undefined : json['format'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'altText': !exists(json, 'altText') ? undefined : json['altText'],
        'galleryIndex': !exists(json, 'galleryIndex') ? undefined : json['galleryIndex'],
    };
}

export function ImageToJSON(value?: Image | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'imageType': value.imageType,
        'format': value.format,
        'url': value.url,
        'altText': value.altText,
        'galleryIndex': value.galleryIndex,
    };
}

